import { useMemo } from 'react'
import { Task } from '../../../types'

interface UseSectionsEnabledProps {
  task: Task
  force?: boolean
}

export function useSectionsEnabled({
  task,
  force = false
}: UseSectionsEnabledProps): boolean {
  const summary = useMemo(() => task?.summary?.v1, [task?.summary?.v1])
  const separate = useMemo(() => summary?.separate, [summary])
  const sections = useMemo(() => summary?.segmentation, [summary])
  const beatschords = useMemo(
    () => summary?.beatschords?.beats?.beatsFile?.url,
    [summary]
  )

  return useMemo(() => {
    if (!(separate?.status === 'COMPLETED')) {
      return force
    }

    const hasSectionsAvailable = sections?.status === 'COMPLETED'

    const hasVocalsAvailable = !!separate?.stems?.find(
      (stem) => stem.stem === 'vocals'
    )

    const hasBeatsMapAvailable = !!beatschords

    if (
      (!hasBeatsMapAvailable && !hasSectionsAvailable && !hasVocalsAvailable) ||
      !task?.isDemo
    ) {
      return force
    }

    return !!hasSectionsAvailable
  }, [force, sections, task?.isDemo, separate, beatschords])
}
